import { render, staticRenderFns } from "./AddProjectStep2.vue?vue&type=template&id=0f2d0676&scoped=true"
import script from "./AddProjectStep2.vue?vue&type=script&lang=js"
export * from "./AddProjectStep2.vue?vue&type=script&lang=js"
import style0 from "./AddProjectStep2.vue?vue&type=style&index=0&id=0f2d0676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d0676",
  null
  
)

export default component.exports